import React, { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import useConditions from "../conditions/useConditions";
import useReviews from "../reviews/useReviews";

const useReviewRecommendations = () => {
  const [contextData, builder] = useContext(VariantContextData);
  const { Conditions } = useConditions();
  const { Reviews } = useReviews();

  let variant = contextData.objects.variant;

  const ReviewRecommendations = {
    create: async function (element, payload, options) {
      builder.create(
        "review_recommendations",
        {
          ...(payload || {}),
          element_id: element ? element.id : undefined,
        },
        {
          transform: function (review_recommendation) {
            review_recommendation.open = true;
            return review_recommendation;
          },
          callback: options ? options.callback : undefined,
        }
      );
    },

    duplicate: async function (
      og_review_recommendation,
      payload,
      skip_history
    ) {
      let attributes = {
        options: og_review_recommendation.options,
      };

      if (payload) {
        attributes = { ...attributes, ...payload };
      }

      builder.create("review_recommendations", attributes, {
        callback: async function (review_recommendation) {
          // duplicate conditions
          let conditions = Object.values(variant.conditions).filter(
            (condition) =>
              condition.contactable_type == "ReviewRecommendation" &&
              condition.contactable_id == og_review_recommendation.id &&
              condition.toBeDeleted !== true
          );

          conditions.forEach((condition) => {
            Conditions.duplicate(
              condition,
              {
                contactable_id: review_recommendation.id,
              },
              true
            );
          });
        },
        skip_history: skip_history,
        skip_select: true,
      });
    },

    remove: (review_recommendation) => {
      let message =
        "Are you sure you want to remove this review recommendation? Once your changes are saved, it will be irreversibly deleted.";

      builder.remove("review_recommendations", review_recommendation.id, message);
    },
  };

  let currentHook = ReviewRecommendations;
  return { ReviewRecommendations, currentHook };
};

export default useReviewRecommendations;
